// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/group/date.php
import F from 'offline/filter/constants'
export default {
	name: 'rating.group.date',
	priority: 69,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && filter.rated && filter.rated.date && filter.rated.date.group && (filter.rated.date.group.from || filter.rated.date.group.to)
	},
	run: function(config, filter, data, query) {
		if (filter.rated.date.group.from) query.where('r.rating_date', '>=', filter.rated.date.group.from)
		if (filter.rated.date.group.to) query.where('r.rating_date', '<=', filter.rated.date.group.to)
	}
}
